module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/store_images/2_f2e067f8cde13b20dfe5dc15e26fa23f.png";